export const TYPOGRAPHY_GRADIENTS = ['w-max', 'fill-color-transparent', 'bg-clip-text', 'text-base'];
